<template>
  <div class="bc-white padding-20 br-4">
    <div class="display-flex jc-space-between ai-center mb-20">
      <b class="fs-18">标识标志库</b>
      <el-button type="primary" icon="el-icon-plus" size="small" @click="add">新增</el-button>
    </div>
    <el-tabs :value="String(searchForm.type)" @tab-click="selectType">
      <el-tab-pane
        v-for="item in typeList"
        :key="item.id"
        :label="item.name"
        :name="String(item.id)">
      </el-tab-pane>
    </el-tabs>
    <div class="display-flex jc-space-between ai-center icon-library-toolbar">
      <el-form :inline="true" size="small" v-model="searchForm" class="icon-search-form">
        <el-form-item label="">
          <el-input
            placeholder="标识名称"
            clearable
            v-model="searchForm.fuzzyName"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="viewMode === 'grid'" label="">
          <el-input
            placeholder="设置范围和地点"
            clearable
            v-model="searchForm.useScope"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
      <el-radio-group v-model="viewMode" size="small" class="icon-view-switch" @change="changeViewMode">
        <el-tooltip content="表格视图" placement="top">
          <el-radio-button label="table"><i class="el-icon-tickets"></i></el-radio-button>
        </el-tooltip>
        <el-tooltip content="图片视图" placement="top">
          <el-radio-button label="grid"><i class="el-icon-s-grid"></i></el-radio-button>
        </el-tooltip>
      </el-radio-group>
    </div>
    <el-table
      v-if="viewMode === 'table'"
      border
      :data="tableData">
      <el-table-column
        align="center"
        prop="name"
        label="标识图片">
        <template #default="slotProps">
          <img width="80" :src="slotProps.row.imgUrl" alt="">
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        label="标识名称">
      </el-table-column>
      <el-table-column
        align="center"
        prop="fxWarnSignTypeName"
        label="标识类型">
      </el-table-column>
      <el-table-column
        align="center"
        prop="useScope"
        label="设置范围和地点">
      </el-table-column>
      <el-table-column
        align="center"
        prop="remark"
        label="备注">
      </el-table-column>
      <el-table-column
        align="center"
        width="120px"
        label="操作">
        <template #default="slotProps">
          <el-button @click="edit(slotProps.row)" type="text">编辑</el-button>
          <el-button @click="del(slotProps.row)" class="color-danger" type="text">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-empty v-else-if="!tableData.length" :image-size="80" description="暂无标识"></el-empty>
    <div v-else class="icon-grid">
      <div v-for="item in imageTableData" :key="item.id" class="icon-card">
        <div class="icon-card-image">
          <img :src="item.imgUrl" :alt="item.name">
        </div>
        <div class="icon-card-content">
          <div class="display-flex jc-space-between ai-center icon-card-title">
            <span class="icon-card-name">{{ item.name }}</span>
            <el-tag size="mini">{{ item.fxWarnSignTypeName }}</el-tag>
          </div>
          <div class="icon-card-detail">
            <div>{{ item.useScope || '—' }}</div>
          </div>
          <div v-if="item.remark" class="icon-card-detail remark">
            {{ item.remark }}
          </div>
          <div class="icon-card-actions">
            <el-button @click="edit(item)" type="text">编辑</el-button>
            <el-button @click="del(item)" class="color-danger" type="text">删除</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="viewMode === 'table'" class="display-flex fd-row-reverse mt-20">
      <!-- 表格数据的分页的功能 -->
      <el-pagination
        hide-on-single-page
        @current-change="(val) => {searchForm.page = val}"
        :current-page="searchForm.page"
        :page-size="searchForm.limit"
        background
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      size="500px"
      :title="dialog.title"
      :visible.sync="dialog.show">
      <el-form
          class="diy-top-form"
          :model="dialog.form"
          ref="ruleForm"
          label-width="120px"
          label-position="top"
         >
          <el-form-item
            label="标识图片："
            prop="imgKey"
            :rules="{required: true, message: '请选择图片', trigger: 'change'}">
            <el-upload
              class="height-80"
              accept=".jpg,.png"
              :show-file-list="false"
              :http-request="uploadFile"
              action="">
              <img v-if="dialog.form.imgUrl" width="80" height="80" :src="dialog.form.imgUrl" alt="">
              <div v-else class="width-80 height-80 display-flex ai-center jc-center" style="border: 1px solid #DCDFE6;">
                <i class="el-icon-plus fs-28 color-info"></i>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="标识名称："
            prop="name"
            :rules="{required: true, message: '请输入标识名称', trigger: 'blur'}">
            <el-input placeholder="请输入标识名称" v-model="dialog.form.name"></el-input>
          </el-form-item>
          <el-form-item
            label="标识类型："
            prop="fxWarnSignTypeId"
            :rules="{required: true, message: '请选择标识类型', trigger: 'blur'}">
            <el-select
              class="width-percent-100"
              clearable
              placeholder="请选择标识类型"
              v-model="dialog.form.fxWarnSignTypeId">
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="设置范围和地点："
            prop="useScope"
            :rules="{required: true, message: '请输入设置范围和地点', trigger: 'blur'}">
            <el-input placeholder="请输入设置范围和地点" v-model="dialog.form.useScope"></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input :autosize="{minRows: 4, maxRows: 8}" type="textarea" v-model="dialog.form.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      <template #footer>
        <el-button type="primary" @click="submit">确认</el-button>
        <el-button @click="dialog.show = false">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'IconLibrary',
  components: {},
  props: {},
  data () {
    return {
      showUrl: '',
      typeList: [],
      viewMode: 'grid',
      searchForm: {
        fuzzyName: '',
        useScope: '',
        type: '',
        page: 1,
        limit: 10
      },
      tableData: [],
      total: 0,
      dialog: {
        show: false,
        title: '新增',
        form: {
          id: '',
          fxWarnSignTypeId: '',
          imgUrl: '',
          imgKey: '',
          name: '',
          remark: '',
          useScope: ''
        }
      }
    }
  },
  filters: {},
  computed: {
    /**
     * 监听复杂数据类型的变换
     */
    _searchForm () {
      return JSON.parse(JSON.stringify(this.searchForm))
    },
    imageTableData () {
      const name = this.searchForm.fuzzyName.trim().toLowerCase()
      const useScope = this.searchForm.useScope.trim().toLowerCase()
      return this.tableData
        .filter(item => {
          return (!name || String(item.name || '').toLowerCase().includes(name)) &&
            (!useScope || String(item.useScope || '').toLowerCase().includes(useScope))
        })
        .map((item, index) => ({
          item,
          index,
          numbers: (String(item.remark || '').match(/\d+/g) || []).map(Number)
        }))
        .sort((a, b) => {
          if (!a.numbers.length && !b.numbers.length) {
            return new Date(a.item.createAt).getTime() - new Date(b.item.createAt).getTime() || a.index - b.index
          }
          if (!a.numbers.length) return 1
          if (!b.numbers.length) return -1
          const length = Math.min(a.numbers.length, b.numbers.length)
          for (let i = 0; i < length; i++) {
            if (a.numbers[i] !== b.numbers[i]) return a.numbers[i] - b.numbers[i]
          }
          return a.numbers.length - b.numbers.length || a.index - b.index
        })
        .map(entry => entry.item)
    }
  },
  watch: {
    _searchForm: {
      handler: function (newVal, oldVal) {
        if (this.viewMode === 'grid') {
          if (newVal.type !== oldVal.type) {
            this.searchForm.page = 1
            this.getTableData()
          }
          return
        }
        if (newVal.page !== 1 && newVal.page === oldVal.page) {
          this.searchForm.page = 1;
        } else {
          this.getTableData()
        }
      },
      deep: true
    }
  },
  methods: {
    resetSearch () {
      this.searchForm.fuzzyName = ''
      this.searchForm.useScope = ''
      this.searchForm.page = 1
      if (this.viewMode === 'table') this.getTableData()
    },
    search () {
      if (this.viewMode === 'table') this.getTableData()
    },
    selectType (tab) {
      const selectedType = this.typeList.find(item => String(item.id) === tab.name)
      if (selectedType) {
        this.searchForm.type = selectedType.id
        this.searchForm.page = 1
      }
    },
    changeViewMode () {
      this.searchForm.page = 1
      this.getTableData()
    },
    add () {
      this.dialog = {
        show: true,
        title: '新增',
        form: {
          id: '',
          fxWarnSignTypeId: this.searchForm.type,
          imgUrl: '',
          imgKey: '',
          name: '',
          remark: '',
          useScope: ''
        }
      }
    },
    edit (row) {
      this.dialog = {
        show: true,
        title: '编辑',
        form: {
          id: row.id,
          fxWarnSignTypeId: row.fxWarnSignTypeId,
          imgUrl: row.imgUrl,
          imgKey: row.imgKey,
          name: row.name,
          remark: row.remark,
          useScope: row.useScope
        }
      }
    },
    del (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.iconLibrary.del({ id: row.id }).then(res => {
          this.$message.success('删除成功')
          this.searchForm.page = 1
          this.getTableData()
        })
      }).catch(() => {});
    },
    uploadFile (e) {
      const loading = this.$loading({
        lock: true,
        text: '上传中,请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const param = new FormData()
      param.append('file', e.file)
      this.$api.common.upload(param).then(res => {
        this.dialog.form.imgUrl = res.url
        this.dialog.form.imgKey = res.key
        loading.close()
      }).catch(() => {
        loading.close()
      })
    },
    submit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.dialog.form.id) {
            this.$api.iconLibrary.update(this.dialog.form).then(res => {
              this.$message.success('编辑成功')
              this.getTableData()
              this.dialog.show = false
            })
          } else {
            this.$api.iconLibrary.save(this.dialog.form).then(res => {
              this.$message.success('添加成功')
              this.searchForm.page = 1
              this.getTableData()
              this.dialog.show = false
            })
          }
        }
      })
    },
    getTableData: _.debounce(function () {
      const data = {
        pageNum: this.viewMode === 'grid' ? 1 : this.searchForm.page,
        pageSize: this.viewMode === 'grid' ? 999 : this.searchForm.limit,
        name: this.viewMode === 'grid' ? '' : this.searchForm.fuzzyName,
        fxWarnSignTypeId: this.searchForm.type
      }
      this.$api.iconLibrary.list(data).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    }, 500)
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    this.$api.iconLibrary.type().then(res => {
      this.typeList = res
      this.searchForm.type = res.length ? res[0].id : ''
      this.getTableData()
    })
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.icon-library-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.icon-search-form {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  min-width: 0;
}

.icon-search-form ::v-deep .el-form-item {
  margin-bottom: 0;
}

.icon-view-switch {
  flex-shrink: 0;
}

.icon-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 16px;
}

.icon-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
}

.icon-card-image {
  display: flex;
  height: 150px;
  align-items: center;
  justify-content: center;
  background: #f7f8fa;
}

.icon-card-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.icon-card-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 12px;
}

.icon-card-title {
  gap: 8px;
}

.icon-card-name {
  min-width: 0;
  overflow: hidden;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icon-card-detail {
  margin-top: 10px;
  color: #606266;
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.icon-card-detail.remark {
  color: #a6a9ad;
}

.icon-card-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 8px;
}

@media (max-width: 600px) {
  .icon-library-toolbar {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .icon-search-form {
    flex-wrap: wrap;
  }

  .icon-view-switch {
    margin-left: auto;
  }

  .icon-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
}
</style>
